import { render, staticRenderFns } from "./index.vue?vue&type=template&id=393d2454&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=393d2454&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d2454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393d2454')) {
      api.createRecord('393d2454', component.options)
    } else {
      api.reload('393d2454', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=393d2454&scoped=true", function () {
      api.rerender('393d2454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/WithdrawalDetails/index.vue"
export default component.exports